<script lang="ts">
const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_json_value.name',
	description: '$t:blocks.display_json_value.description',
	icon: 'lucide:braces',
	category: 'display',
	hidden: true,

	fieldBinding: {
		supportedTypes: ({ primitiveType }) => isPrimitiveTypeJson(primitiveType) ? ['json'] : [],
	},
}
</script>
<script setup lang="ts">
import type { DisplayBlockProps } from '#layers/blocks/types/display-block';
import type { JsonValue } from '#layers/data-model/public';
import { computed } from 'vue';
import { defineBlock } from '#layers/block-engine/public';
import { isPrimitiveTypeJson } from '#layers/data-model/public';
import { useDisplayTemplateNode } from './use-display-template-node';

/** Props for rendering a native JSON value as compact display text. */
interface DisplayJsonValueBlockProps extends DisplayBlockProps<JsonValue> {}

const props = defineProps<DisplayJsonValueBlockProps>();

;

const content = computed(() => formatJsonDisplayValue(props.value));
const { isNestedDisplayTemplateNode, displayTemplateNodeElement } = useDisplayTemplateNode(() => props.root);
const rootClasses = computed(() => {
	if (isNestedDisplayTemplateNode.value) {
		return 'flex min-w-0 items-center';
	}

	return 'flex min-w-0 items-center overflow-hidden';
});

/**
 * Formats native JSON values without pretty-printing so table cells stay one line.
 */
function formatJsonDisplayValue(value: JsonValue | undefined): string {
	if (value === undefined) return '';
	return JSON.stringify(value);
}
</script>

<template>
	<component :is="displayTemplateNodeElement" :class="rootClasses">
		<span
			class="font-mono"
			:class="{
				'truncate': !isNestedDisplayTemplateNode,
				'min-w-0 overflow-hidden text-ellipsis whitespace-pre': isNestedDisplayTemplateNode,
			}"
		>
			{{ content }}
		</span>
	</component>
</template>
